import React, { useEffect } from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'
const Option = Select.Option

@Form.create()
class StaffLeaveAction extends React.Component {
    state = {
        visible: true,
        loading: false,
        leaveApproved: false,
        leaveTypes: ['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'HD(Half Day)'],
        sandwichLeaveDetails: [],
        casualLeaveDetails: [],
        companySetting: {},
        activeUser: {}
    }

    async componentDidMount() {
        let activeUser = JSON.parse(localStorage.getItem('user'))
        let companySetting = await Request.getCompanySetting({ businessId: activeUser.businessId })
        this.setState({ activeUser: activeUser, companySetting: companySetting })
    }

    setFormDetails() {
        let { record, form } = this.props;
        setTimeout(() => {
            form.setFieldsValue({
                startDate: moment(record.startDate),
                endDate: moment(record.endDate),
                leaveDuration: record.leaveDuration,
                leaveType: record.leaveType
            })
        }, 150)
    }

    async getLeaveDetails() {
        let sandwichLeaveDetails = await this.getSandwichLeaveDetails();
        let casualLeaveDetails = await this.getCasualLeaveDetails();
        this.setState({ sandwichLeaveDetails, casualLeaveDetails })
        let { companySetting } = this.state
        let totalSandwichLeavesAllowed = companySetting && companySetting.sandwichAllowedPerYear && companySetting.numberOfSandwichLeaves ? companySetting.numberOfSandwichLeaves : 2
        if (casualLeaveDetails.total >= 1 && sandwichLeaveDetails.total < totalSandwichLeavesAllowed) {
            this.setState({ leaveTypes: ['LWP(Leave Without Pay)', 'HD(Half Day)', 'Sandwich Leave', 'WFH(Work From Home)'] })
        } else if (casualLeaveDetails.total >= 1 && sandwichLeaveDetails.total >= totalSandwichLeavesAllowed) {
            this.setState({ leaveTypes: ['LWP(Leave Without Pay)', 'HD(Half Day)', 'WFH(Work From Home)'] })
        } else if (sandwichLeaveDetails.total >= totalSandwichLeavesAllowed) {
            this.setState({ leaveTypes: ['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'HD(Half Day)', 'WFH(Work From Home)'] })
        } else {
            this.setState({ leaveTypes: ['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'HD(Half Day)', 'Sandwich Leave', 'WFH(Work From Home)'] })
        }
    }

    async getSandwichLeaveDetails() {
        let { record } = this.props
        let data = {
            userId: record.userId,
            leaveType: 'Sandwich Leave',
            leaveYear: moment().format('YYYY'),
            status: "Approved"
        }
        let response = await Request.getUserLeaves(data);
        return response
    }
    async getCasualLeaveDetails() {
        let { record } = this.props
        let data = {
            userId: record.userId,
            leaveType: 'CL(Casual Leave)',
            leaveYearMonth: moment().format('YYYY-MM'),
            status: 'Approved'
        }
        let response = await Request.getUserLeaves(data);
        return response
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleDisApprove = (record) => {

    }

    handleSubmit = e => {
        e.preventDefault();
        const { form, record } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                values._id = record._id
                let response = await Request.updateStaffLeave(values)
                if (!response.error) {
                    this.onClose()
                    notification.success({
                        message: 'Success',
                        description: response.msg
                    })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: response.msg
                    })
                }
            }

        })
    }

    render() {

        let sandwichLeaveColumn = {
            title: 'Leave Date',
            key: 'startDate',
            dataIndex: 'startDate'
        }

        const { visible, leaveTypes, leaveApproved, sandwichLeaveDetails, casualLeaveDetails } = this.state
        const { record } = this.props
        const inputTypes = {
            fields: [
                {
                    label: 'Action',
                    key: 'status',
                    required: true,
                    type: 'select',
                    options: ['Approved', 'Disapproved'],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            status: v
                        })
                        if (v === 'Approved') {
                            this.setState({ leaveApproved: true })
                            this.setFormDetails();
                            this.getLeaveDetails();
                        } else if (v === 'Disapproved') {
                            this.setState({ leaveApproved: false })
                        }
                    }
                },
                {
                    label: 'Start Date',
                    key: 'startDate',
                    required: leaveApproved,
                    type: 'date',
                    hidden: !leaveApproved,
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day'))
                    }
                },
                {
                    label: 'End Date',
                    key: 'endDate',
                    required: leaveApproved,
                    type: 'date',
                    hidden: !leaveApproved,
                    customProps: {
                        disabledDate: d => !d || d.isBefore(moment().add(-1, 'day'))
                    }
                },
                {
                    label: 'Leave Type',
                    key: 'leaveType',
                    required: leaveApproved,
                    type: 'select',
                    hidden: !leaveApproved,
                    options: leaveTypes,
                    onChange: v => {
                        this.props.form.setFieldsValue({ leaveType: v })
                    }
                }
            ]
        }

        const {
            form: { getFieldDecorator, }
        } = this.props

        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Approve/Disapprove
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={400}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
                <Card style={{ textAlign: 'center', width: '100%' }}>
                    <h3>Sandwich Leaves:- {sandwichLeaveDetails.total}</h3>
                    <table>
                        {sandwichLeaveDetails.data && sandwichLeaveDetails.data.map((item) => (
                            <tr>
                                <th>{item.leaveType}</th>
                                <td>{item.startDate}</td>
                            </tr>
                        ))}
                    </table>
                </Card>
                <Card style={{ textAlign: 'center', width: '100%' }}>
                    <h3>Casual Leaves:- {casualLeaveDetails.total}</h3>
                    <table>
                        <tbody>
                            {casualLeaveDetails.data && casualLeaveDetails.data.map((item) => (
                                <tr>
                                    <th>{item.leaveType}</th>
                                    <td>{item.startDate}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StaffLeaveAction)
